import type { GameMeta } from '@gmp/game-sdk';

export const terribleAdviceMeta = {
  id: 'terrible-advice',
  name: 'Terrible Advice',
  tagline: 'Someone has an absurd problem. Everyone has an even worse solution. Guess which one they take.',
  description:
    'A fictional character writes in to the advice column with an absurd everyday disaster. Pick a strategy (overcomplicate it, blame someone else, embrace chaos, fake confidence or do nothing) and write one piece of terrible advice. The answers go up anonymously; vote for the one you think the group will prefer, give a separate nod to the funniest, and lock in which strategy will win before the dramatic decision. Play in one sitting or over a few days.',
  minPlayers: 3,
  maxPlayers: 12,
  estimatedMinutes: [10, 25],
  usesMedia: false,
  modes: [{ id: 'column', name: 'Advice column', description: 'Three letters by default, or one per player (up to eight).' }],
  theme: { primary: '#ffd447', secondary: '#ff6f91', background: '#1b1530', ink: '#fff8e7' },
  readiness: 'beta',
  genre: 'Comedy writing and group prediction',
  controls: 'tap',
  category: 'async',
  asyncInfo: {
    turnSeconds: [20, 60],
    match: { quick: '10–25 min', daily: '4–8 days' },
    difficulty: 'easy',
    tags: ['funny', 'writing', 'prediction'],
  },
  instructions: [
    { icon: 'Newspaper', title: 'A letter arrives', body: 'Each round a fictional character writes in with an absurd problem: a collapsed cake, a goat that ate the fence, a queue of confused Steves.' },
    { icon: 'PenLine', title: 'Pick an angle, write advice', body: 'Choose a strategy (overcomplicate it, blame someone else, embrace chaos, fake confidence or do nothing) and write one short piece of terrible advice.' },
    { icon: 'Vote', title: 'Vote and predict', body: 'The advice goes up anonymously. Vote for the one the group will prefer (never your own), optionally pick the funniest, and lock in which strategy will win.' },
    { icon: 'Trophy', title: 'The decision', body: 'The character takes the winning advice: +3 to its writer, +1 to any other advice that got a vote, +2 for calling the winning strategy, and up to +2 for funniest votes. Steps move on when everyone is in or time runs out.' },
  ],
} satisfies GameMeta;
